// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__zRoWI","navLink":"Nav_navLink__hlaZy"};